import { useEffect } from "react";
import Hero from "@/components/landing/Hero";
import TrustMarquee from "@/components/landing/TrustMarquee";
import Problem from "@/components/landing/Problem";
import Features from "@/components/landing/Features";
import Destinations from "@/components/landing/Destinations";
import HowItWorks from "@/components/landing/HowItWorks";
import Experience from "@/components/landing/Experience";
import Occasions from "@/components/landing/Occasions";
import BookingSection from "@/components/landing/BookingSection";
import Faq from "@/components/landing/Faq";
import Journal from "@/components/landing/Journal";
import FinalCta from "@/components/landing/FinalCta";
import { scrollToId } from "@/lib/site";

const HomePage = () => {
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.slice(1);
            const t = setTimeout(() => scrollToId(id), 500);
            return () => clearTimeout(t);
        }
    }, []);

    return (
        <main>
            <Hero />
            <TrustMarquee />
            <Problem />
            <Features />
            <Destinations />
            <HowItWorks />
            <Experience />
            <Occasions />
            <BookingSection />
            <Faq />
            <Journal />
            <FinalCta />
        </main>
    );
};

export default HomePage;
